const adminModelKeys = {
  actions: {
    add: '新增分发密钥',
    delete: '删除',
    edit: '编辑',
    open: '打开 {{name}} 的操作菜单',
    rotate: '轮换密钥',
  },
  columnSelector: {
    label: '选择模型分发列表列',
    trigger: '列',
  },
  deleteDialog: {
    cancel: '取消',
    close: '关闭删除确认',
    confirm: '删除',
    failed: '分发密钥删除失败',
    message: '确认删除分发密钥 {{name}}？删除后，已接入该密钥的客户端会立即失效。',
    subtitle: '该操作只删除分发密钥，不删除已注册模型。',
    success: '分发密钥已删除',
    title: '删除分发密钥？',
  },
  description: '管理对外分发密钥、输出协议、可调用模型和配额规则。',
  drawer: {
    cancel: '取消',
    createTitle: '新增分发密钥',
    detailLoadFailed: '请稍后重试，或检查当前管理员是否仍有模型网关访问权限。',
    detailLoadFailedTitle: '分发密钥详情加载失败',
    editTabs: {
      basic: '基础配置',
      label: '分发密钥编辑页签',
      models: '模型选择',
      quota: '配额规则',
      view: '查看',
    },
    editTitle: '编辑 / {{name}}',
    feedback: {
      createSuccess: '分发密钥创建成功',
      submitFailed: '保存失败',
      updateSuccess: '分发密钥保存成功',
      validationFailed: '请先修正表单内容',
    },
    fields: {
      enabled: '是否启用',
      name: '密钥名称',
      outputProtocol: '输出协议',
    },
    models: {
      description: '选择该密钥可以调用的注册模型。运行时由网关按策略路由。',
      empty: '暂无可选注册模型',
      noMatches: '没有匹配的注册模型',
      searchLabel: '搜索可选模型',
      searchPlaceholder: '搜索模型或接口协议',
      title: '可调用模型',
      unavailable: '已停用或不可用',
    },
    placeholders: {
      name: '例如：platform-internal-eval',
    },
    save: '保存',
    submitFailed: '保存分发密钥失败，请稍后重试。',
    validation: {
      allowedModelsRequired: '请选择至少一个可调用模型',
      allowedModelsUnavailable: '请移除已停用或不可用的模型',
      nameRequired: '请输入密钥名称',
      protocolRequired: '请选择输出协议',
      quotaActionRequired: '请选择配额处理动作',
      quotaCurrencyRequired: '费用配额需要填写币种',
      quotaMetricRequired: '请选择配额指标',
      quotaScopeRequired: '请选择配额范围',
      quotaThresholdRequired: '请输入有效阈值',
      quotaWindowRequired: '请选择统计窗口',
    },
    wizard: {
      create: '创建密钥',
      headerDescription: '第 {{current}} / {{total}} 步',
      next: '下一步',
      previous: '上一步',
      progressLabel: '新增分发密钥进度：第 {{current}} / {{total}} 步，当前为{{step}}',
      steps: {
        key: {
          title: '基础配置',
        },
        models: {
          title: '模型配置',
        },
        quota: {
          title: '配额规则',
        },
      },
    },
    view: {
      copyEndpoint: '复制 endpoint',
      copyFailed: '复制失败，请手动复制',
      copyModel: '复制模型名称 {{name}}',
      copySuccess: '已复制',
      endpoint: 'Endpoint',
      endpointDescription: '客户端使用该 endpoint 和分发密钥调用模型网关。',
      endpointTitle: '调用 Endpoint',
      modelsDescription: '请求体中的 model 使用下列对外模型名称。',
      modelsEmpty: '暂无可调用模型。',
      modelsTitle: '可调用模型名称',
    },
  },
  empty: '暂无分发密钥',
  errorDescription: '请稍后重试，或检查当前管理员是否仍有访问权限。',
  errorDescriptionWithDetail: '后端返回：{{detail}}',
  errorTitle: '分发密钥列表加载失败',
  filters: {
    allStatuses: '所有状态',
    searchLabel: '搜索分发密钥',
    searchPlaceholder: '搜索密钥名称、前缀或协议',
    statusLabel: '筛选密钥状态',
  },
  pagination: {
    next: '下一页',
    pageSize: '{{count}} 条/页',
    previous: '上一页',
  },
  quota: {
    action: '处理动作',
    actions: {
      block: '阻断请求',
      notify_only: '仅记录告警',
    },
    addRule: '添加规则',
    currency: '币种',
    currencyPlaceholder: '例如：USD',
    description: '按请求数、token、费用或并发数限制该密钥的模型调用。',
    disabled: '停用',
    empty: '当前没有配置配额规则。',
    enabled: '启用',
    enabledLabel: '切换第 {{index}} 条配额规则',
    metric: '配额指标',
    metrics: {
      completion_tokens: '输出 tokens',
      concurrency: '并发数',
      cost_amount: '费用金额',
      prompt_tokens: '输入 tokens',
      request_count: '请求数',
      total_tokens: '总 tokens',
    },
    priority: '优先级',
    removeRule: '移除',
    ruleTitle: '规则 {{index}}',
    scope: '范围',
    scopeValue: '范围值',
    scopeValuePlaceholder: '可选，指定模型名或模型 ID',
    scopes: {
      all_models: '全部模型',
      per_public_model: '按展示模型',
      per_registered_model: '按注册模型',
    },
    threshold: '阈值',
    title: '配额规则',
    window: '统计窗口',
    windows: {
      all_time: '全部时间',
      day: '每日',
      hour: '每小时',
      minute: '每分钟',
      month: '每月',
    },
  },
  reveal: {
    close: '关闭密钥明文弹窗',
    confirm: '我已保存',
    copyFailed: '复制失败，请手动复制',
    copySecret: '复制密钥明文',
    copySuccess: '分发密钥已复制',
    description: '密钥明文只在创建或轮换后显示一次，请在离开页面前保存到安全位置。',
    secret: '密钥明文',
    title: '{{name}} 的密钥明文',
  },
  retry: '重试',
  rotateDialog: {
    cancel: '取消',
    close: '关闭轮换确认',
    confirm: '轮换',
    failed: '分发密钥轮换失败',
    message: '确认轮换分发密钥 {{name}}？旧密钥会立即失效。',
    subtitle: '轮换后会显示新的密钥明文，请及时更新客户端。',
    success: '分发密钥已轮换',
    title: '轮换分发密钥？',
  },
  status: {
    active: '启用',
    disabled: '停用',
  },
  table: {
    actions: '操作',
    allowedModels: '可调用模型',
    createdAt: '创建时间',
    createdBy: '创建人',
    key: '密钥',
    name: '密钥名称',
    noQuota: '未配置',
    outputProtocol: '输出协议',
    quota: '配额',
    status: '状态',
  },
  title: '模型分发',
  workspaceLabel: '模型分发工作区',
}

export default adminModelKeys
